// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iVS9O{width:100%;margin:0 auto}@media screen and (min-width:768px){._7CNl2.YktA6{background-color:#fff}}@media screen and (min-width:768px){.DigSs.AqZb9+.DigSs.AqZb9{padding-top:16px}}@media screen and (min-width:1552px){.DigSs.AqZb9+.DigSs.AqZb9{padding-top:8px}}.LUXxe{display:flex;height:100%;flex-flow:column}.iAjGx{flex:0 0 auto}.iAjGx.qfCGJ{flex-grow:1}.iAjGx:not(:first-child){padding-top:24px}.e1RiS{position:sticky;top:112px}@media screen and (min-width:1236px){.e1RiS{top:72px}}.exzL1{margin-bottom:20px}@media screen and (min-width:1024px){.exzL1{width:calc(100% - 312px)}}.tJBUp{margin-bottom:8px}@media screen and (min-width:768px){.QrxjM{margin-bottom:20px}}@media screen and (min-width:1236px){[data-a11y~=visible-bar] .e1RiS{top:184px}}@media screen and (min-width:1552px){[data-a11y~=visible-bar] .e1RiS{top:138px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": "iVS9O",
	"pageArticle": "_7CNl2",
	"isFranchise": "YktA6",
	"article": "DigSs",
	"isFolded": "AqZb9",
	"sidebar": "LUXxe",
	"sidebarItem": "iAjGx",
	"isSticky": "qfCGJ",
	"adfox": "e1RiS",
	"loaderObserver": "exzL1",
	"news": "tJBUp",
	"readMore": "QrxjM"
};
module.exports = ___CSS_LOADER_EXPORT___;
